import { render, staticRenderFns } from "./Bantuan.vue?vue&type=template&id=2d890358&scoped=true&"
import script from "./Bantuan.vue?vue&type=script&lang=js&"
export * from "./Bantuan.vue?vue&type=script&lang=js&"
import style0 from "./Bantuan.vue?vue&type=style&index=0&id=2d890358&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d890358",
  null
  
)

export default component.exports